module.exports = __webpack_public_path__ + "img/COVID-19-Response-1110x450.bf5ff41a.png";